import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight, LayoutGrid } from "lucide-react";
import { Reveal } from "./Shared";

const PORTAL_APPS = [
  { key: "mastertg", name: "Master TG", desc: "Plateforme intelligente : QCM, scanner IA, flashcards, plans 2D/3D et modules BTP.", preview: "/portal/mastertg.png", url: "https://master-tg.ai.studio/", external: true },
  { key: "kago", name: "KaGo", desc: "Transport & mobilité : VTC, livraison de repas et courses au quotidien.", preview: "/portal/kago.png", url: "https://kago02.ai.studio", external: true },
  { key: "maison", name: "Une Maison pour Tous", desc: "Immobilier en Afrique : location et vente de biens avec annonces vérifiées.", preview: "/portal/maison.png", url: "https://une-maison-pour-tous.ai.studio", external: true },
  { key: "bonafricain", name: "Bon Africain", desc: "La marketplace africaine pour acheter et vendre près de chez vous, en toute confiance.", preview: "/portal/bonafricain.png", url: "https://bon-africain.ai.studio", external: true },
  { key: "ctqibla", name: "CTQIBLA", desc: "Votre compagnon pour l'Omra & le Hajj : Qibla, horaires de prière et Coran.", preview: "/portal/ctqibla.png", url: "https://ctqibla2.ai.studio", external: true },
  { key: "kazi", name: "Kazi TG", desc: "Gestion de commerce : ventes, stock et assistant intelligent pour commerçants.", preview: "/portal/kazi.png", url: "https://kazi-tg0.ai.studio", external: true },
  { key: "salam", name: "Salam TG", desc: "Votre assistant islamique : questions, versets du Coran et conseils spirituels.", preview: "/portal/salam.png", url: "https://salam-tg0.ai.studio", external: true },
];

const CardInner = ({ app }) => (
  <>
    <div className="relative aspect-[16/10] overflow-hidden bg-navy/20">
      <img
        src={app.preview}
        alt={`Aperçu de ${app.name}`}
        loading="lazy"
        className="h-full w-full object-cover object-top transition-transform duration-[800ms] ease-out group-hover:scale-[1.06]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy/70 via-transparent to-transparent opacity-80" />
      <span className="absolute right-3 top-3 grid h-9 w-9 place-items-center rounded-full bg-gold text-navy opacity-0 shadow-lg transition-all duration-300 group-hover:opacity-100">
        <ArrowUpRight size={17} />
      </span>
    </div>
    <div className="flex flex-1 flex-col p-5">
      <h3 className="font-display text-lg font-bold text-white">{app.name}</h3>
      <p className="mt-1.5 flex-1 text-sm leading-relaxed text-white/60">{app.desc}</p>
      <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-gold-400">
        Découvrir
        <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
      </span>
    </div>
  </>
);

const cardClass =
  "group flex h-full flex-col overflow-hidden rounded-3xl border border-gold/30 bg-white/[0.04] shadow-[0_14px_50px_-20px_rgba(0,0,0,0.6)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-gold/60 hover:shadow-[0_28px_60px_-22px_rgba(200,164,77,0.4)]";

export const AppsPortal = () => {
  return (
    <section data-testid="apps-portal-section" className="relative overflow-hidden bg-navy py-20 sm:py-28">
      <div className="pointer-events-none absolute -right-20 top-10 h-80 w-80 rounded-full bg-gold/10 blur-[120px]" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-gold/10 blur-[120px]" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-sm font-medium text-gold-400">
              <LayoutGrid size={15} /> L'écosystème numérique TIRERA GROUP
            </span>
            <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
              Nos applications
            </h2>
            <p className="mt-4 text-base text-white/60 sm:text-lg">
              Un seul groupe, tout un écosystème. Découvrez et ouvrez directement chacune de nos applications.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {PORTAL_APPS.map((app, i) => (
            <Reveal key={app.key} i={i}>
              {app.external ? (
                <a
                  href={app.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`portal-app-${app.key}`}
                  className={cardClass}
                >
                  <CardInner app={app} />
                </a>
              ) : (
                <Link to={app.url} data-testid={`portal-app-${app.key}`} className={cardClass}>
                  <CardInner app={app} />
                </Link>
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
